import { useApi } from '../composables/useApi.js'

export const useSharedFetcher = () => {
  const Api = useApi()

  return async ({ method, path, params, body }) => {
    const query = params && Object.keys(params).length
      ? `?${new URLSearchParams(params).toString()}`
      : ''
    const url = `${path}${query}`
    const methodName = method.toLowerCase()
    const request = body !== undefined ? Api(url)[methodName](body) : Api(url)[methodName]()
    const { data, error } = await request.json()

    if (error.value) {
      throw error.value instanceof Error ? error.value : new Error(String(error.value))
    }

    return data.value
  }
}
